import { createQuery } from '@amzn/gsce-shared-react-lib';
import {
  GetAuditCommand,
  type GetAuditCommandInput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient, withRetry } from '../../../shared/data';
import { AuditQueryKeys } from './keys';

/**
 * Query hook for fetching a single audit by ID.
 *
 * Uses createQuery from GsceSharedReactLib which auto-maps query params
 * to the cache key — no manual key factory needed.
 *
 * Usage:
 * ```tsx
 * const { data, isLoading } = useAuditDetailQuery(
 *   { businessUnitId, auditId },
 *   { enabled: !!businessUnitId && !!auditId },
 * );
 * ```
 */
export const useAuditDetailQuery = createQuery(
  AuditQueryKeys.details,
  (input: GetAuditCommandInput) =>
    withRetry(() => apiHeliosClient.send(new GetAuditCommand(input))),
);
